// C8 方案 A：顧客端 QR session token cache
// 流程：QR URL 帶 qrt=<long_token> → 存 sessionStorage → 送單前換 5-min session
//
// API:
//   captureLongTokenFromUrl(slug, table)  從當前 URL 抓 ?qrt= 並 cache
//   getLongToken(slug, table)              取 cache 的長期 token
//   getFreshSessionToken(slug, table)      回 5-min session token（自動 refresh / 沒 long token 回 null）

import { exchangeQrSession } from './api.js';

function longKey(slug, table) { return `qr-long:${slug}:${table}`; }
function sessKey(slug, table) { return `qr-sess:${slug}:${table}`; }

/**
 * 從當前 hash 抓 ?qrt= 並存進 sessionStorage（呼叫 router 進場時用）
 * URL 範例：#/order/laopo/5?qrt=BASE64...
 */
export function captureLongTokenFromUrl(slug, table) {
  if (!slug || !table) return null;
  const qIdx = location.hash.indexOf('?');
  if (qIdx < 0) return null;
  const qs = new URLSearchParams(location.hash.slice(qIdx + 1));
  const qrt = qs.get('qrt');
  if (qrt) {
    try {
      sessionStorage.setItem(longKey(slug, table), qrt);
    } catch {}
  }
  return qrt || null;
}

export function getLongToken(slug, table) {
  try {
    return sessionStorage.getItem(longKey(slug, table));
  } catch { return null; }
}

/**
 * 取得 5-min session token：
 *   - cache 內未過期 → 直接回
 *   - 否則用 long token 換新 session
 *   - 沒 long token → 回 null（呼叫端走 demo 路徑，不帶 qr_token）
 */
export async function getFreshSessionToken(slug, table) {
  const longToken = getLongToken(slug, table);
  if (!longToken) return null;

  // 檢查 cache（含過期判斷，剩 < 30 秒就換新）
  try {
    const raw = sessionStorage.getItem(sessKey(slug, table));
    if (raw) {
      const { token, expiresAt } = JSON.parse(raw);
      const remainMs = new Date(expiresAt).getTime() - Date.now();
      if (token && remainMs > 30_000) return token;
    }
  } catch {}

  // 換新
  const { session_token, expires_at } = await exchangeQrSession(longToken);
  try {
    sessionStorage.setItem(
      sessKey(slug, table),
      JSON.stringify({ token: session_token, expiresAt: expires_at }),
    );
  } catch {}
  return session_token;
}

/** 顧客送單成功後可選擇清掉 session（下一桌 / 下次掃會自動補） */
export function clearSession(slug, table) {
  try { sessionStorage.removeItem(sessKey(slug, table)); } catch {}
}
